export default {
  methods: {
    setPageTitle(title) {
      document.title = `${title} - GEPI.io`;
    },
  },
};
